import React from "react";

export enum IconName {
	none,
	darkCheck,
	whiteCheck,
	darkX
}

type IconProps = {
	name:IconName
	className?: string
}

export default function Icon({name, className}:IconProps) {
	//For conditional icons
	if(name === IconName.none) {
		return <></>;
	}
	return <img className={className} alt={IconName[name]}
				srcSet={`/assets/icons/common/${IconName[name]}.png, /assets/icons/common/${IconName[name]}@2x.png 2x`}
				src={`/assets/icons/common/${IconName[name]}.png`}/>;
}